<template>
  <div>
    <p>Dernière mise à jour : 19 Novembre 2019</p>
    <p>La présente politique de confidentialité définit et vous informe de la
      manière dont {{ site }} utilise et protège les informations que vous nous
      transmettez, le cas échéant, lorsque vous utilisez le présent site
      accessible à partir de l’URL suivante : https://{{ site }}
      (ci-après le « Site »).
    </p>

    <p>Cette politique de confidentialité est susceptible d’être modifiée ou
      complétée à tout moment par {{ site }}, notamment en vue de se conformer à
      toute évolution législative, règlementaire, jurisprudentielle ou technologique.
    </p>

    <p>Conformément à la loi dite « Informatique et Libertés » du 6 janvier 1978
      et Règlement Général sur la Protection des Données 2016/679 (RGPD), la
      présente politique de confidentialité décrit la façon dont nous
      collectons, utilisons, conservons et protégeons vos données personnelles,
      lorsque vous utilisez notre site accessible à partir de l’URL suivante :
      https://{{ site }}</p>

    <h3>— PROTECTION DES DONNÉES PERSONNELLES —</h3>

    <p>1. IDENTITÉ DU RESPONSABLE DU TRAITEMENT<br>
    Le responsable du traitement des données personnelles est Yannick Touchard,
    Dirigeant-fondateur de la Société Bikini.Agency, société au capital de
    1 000 euros, immatriculée auprès du Registre du Commerce et des Sociétés de
    Paris sous le numéro 821 295 763, dont le siège social est situé au 89
    avenue secretan 75019 Paris – France.</p>

    <p>Téléphone : 09 51 50 04 40 – Email : contact@{{ site }}</p>

    <p>2. NATURE DES DONNÉES COLLECTÉES<br>
    D’une manière générale, il vous est possible de visiter notre site sans
    communiquer d’informations personnelles vous concernant. En toute hypothèse,
    vous n’êtes en aucune manière obligé de transmettre ces informations à
    {{ site }}.</p>

    <p>Sous réserve des lois applicables, nous collectons des données vous
      concernant ou concernant tout tiers dont vous nous fournissez les
      informations lorsque vous remplissez le formulaire de paiement en ligne.
      Cela inclut l'ensemble des informations nécessaires à la réalisation de
      votre commande mais aussi à l'édition d'une facture correspondant la commande.</p>

    <p>En fournissant ces informations, vous acceptez expressément qu’elles
      soient traitées par {{ site }}, aux fins indiquées ci-dessous.</p>

    <p>3. FINALITÉ DES TRAITEMENTS<br>
    Sous réserve des lois applicables, nous collectons et traitons vos données
    personnelles pour les finalités suivantes :</p>

    <p>L’amélioration de la navigation sur le site et le recueil d’informations,
      par le biais de cookies de votre navigation pour améliorer la qualité de la navigation,<br>
    La réalisation de l'acte d'achat proposé par {{ site }}</p>

    <p>4. DESTINATAIRES<br>
    Les données personnelles vous concernant collectées sur le site sont
    destinées à {{ site }} et peuvent être transmises aux sociétés sous-traitantes
    auxquelles {{ site }} peut faire appel dans le cadre de l’exécution de ses services.</p>

    <p>{{ site }} a vérifié la conformité avec les exigences de protection des données pour toutes ses sociétés sous-traitantes.</p>

    <p>En aucun cas, {{ site }} ne vend ni ne loue vos données personnelles à des tiers à des fins de marketing.
    Actuellement, les destinataires des données peuvent être :<br>
    Google et Google Analytics (USA) (gestion des publicités et des données analytiques)<br>
    Stripe.com (USA) (gestion des paiements)</p>

    <p>5. DURÉE DE CONSERVATION<br>
    Vos données personnelles sont conservées par Stripe solution de paiement en
    ligne, pour une durée de 36 mois correspondant à la durée légale de conservation
    des données de facturation.</p>

    <p>6. DROIT INFORMATIQUE ET LIBERTÉ<br>
    Conformément à la loi « Informatique et Libertés » et le Règlement Général
    sur la Protection des Données (RGPD), vous disposez des droits suivants
    concernant vos données personnelles, que vous pouvez exercer en nous écrivant
    à l’adresse email (contact@{{ site }}), à l’adresse postale (cf. point 1)</p>

    <p>Droit d’accès et de communication des données<br>
    Vous avez la faculté d’accéder aux données personnelles qui vous concernent.
    Cependant, en raison de l’obligation de sécurité et de confidentialité dans
    le traitement des données à caractère personnel qui incombe à {{ site }},
    vous êtes informé que votre demande sera traitée sous réserve que vous
    rapportiez la preuve de votre identité.<br>
    Pour vous aider dans votre démarche, notamment si vous désirez exercer votre
    droit d’accès par le biais d’une demande écrite à l’adresse postale
    mentionnée au point 1, vous trouverez en cliquant sur le lien suivant un
    modèle de courrier élaboré par la Commission Nationale de l’Informatique et
    des Libertés (la « CNIL ») : https://www.cnil.fr/fr/modele/courrier/exercer-son-droit-dacces</p>

    <p>Droit de rectification des données<br>
    Au titre de ce droit, la législation vous habilite à demander la rectification,
    la mise à jour, ou encore l’effacement des données vous concernant qui peuvent
    s’avérer le cas échéant inexactes, erronées, incomplètes ou obsolètes.<br>
    Pour vous aider dans votre démarche, notamment si vous désirez exercer votre
    droit de rectification par le biais d’une demande écrite à l’adresse postale
    mentionnée au point 1, vous trouverez en cliquant sur le lien suivant un
    modèle de courrier élaboré par la CNIL : https://www.cnil.fr/fr/modele/courrier/rectifier-des-donnees-inexactes-obsoletes-ou-perimees</p>

    <p>Droit d’opposition<br>
    L’exercice de ce droit est possible lorsqu’il vise à faire obstacle à ce que
    les données recueillies soient utilisées à des fins de prospection commerciale.<br>
    Pour vous aider dans votre démarche, notamment si vous désirez exercer votre
    droit d’opposition par le biais d’une demande écrite adressée à l’adresse postale
    indiquée au point 1, vous trouverez en cliquant sur le lien suivant un modèle
    de courrier élaboré par la CNIL : https://www.cnil.fr/fr/modele/courrier/supprimer-des-informations-vous-concernant-dun-site-internet</p>

    <p>7. DÉLAI DE RÉPONSE<br>
    {{ site }} s’engage à répondre à votre demande d’accès, de rectification ou
    d’opposition ou toute autre demande complémentaire d’informations dans un délai
    raisonnable qui ne saurait dépasser 30 jours à compter de la réception de votre demande.</p>

    <p>8. PLAINTE AUPRÈS DE L’AUTORITÉ COMPÉTENTE<br>
    Si vous considérez que {{ site }} ne respecte pas ses obligations au regard
    de vos données personnelles passé le délai des 30 jours, vous pouvez adresser
    une plainte ou une demande auprès de l’autorité compétente.</p>

    <p>En France, l’autorité compétente est la CNIL à laquelle vous pouvez
      adresser une demande par voie électronique en cliquant sur le lien suivant : https://www.cnil.fr/fr/plaintes/internet</p>

    <h3>— POLITIQUE RELATIVE AUX COOKIES —</h3>

    <p>9. QU’EST-CE QU’UN COOKIE ?<br>
    Lors de votre première connexion sur le site web de {{ site }}, vous êtes
    averti par un bandeau en bas de votre écran que des informations relatives à
    votre navigation sont susceptibles d’être enregistrées dans des fichiers
    dénommés « cookies ».</p>

    <p>Les « cookies » (ou témoins de connexion) sont des petits fichiers texte
      de taille limitée qui nous permettent de reconnaître votre ordinateur, votre
      tablette ou votre mobile aux fins de personnaliser les services que nous vous proposons.</p>

    <p>10. FINALITÉ DES COOKIES<br>
    Les informations recueillies par le biais des cookies ne permettent en aucune
    manière de vous identifier nominativement. Elles sont utilisées exclusivement pour nos besoins propres.</p>

    <p>Pour mieux vous éclairer sur les informations que les cookies identifient,
      vous trouverez ci-dessous la liste des différents types de cookies susceptibles
      d’être utilisés sur {{ site }}, leur nom, leur finalité ainsi que leur durée de conservation.</p>

    <p>11.FONCTIONNALITÉ DES COOKIES<br>
    Le recueil ou non de votre consentement dépend du type de cookie :</p>

    <p>cookies exemptés de consentement (cookies techniques) : conformément aux
      recommandations de la Commission Nationale de l’Informatique et des Libertés
      (CNIL), certains cookies, annoncés par une bannière lors de votre première
      connexion sur {{ site }}, sont dispensés du recueil préalable de votre
      consentement dans la mesure où ils sont strictement nécessaires au
      fonctionnement du site internet ou ont pour finalité exclusive de permettre
      ou faciliter la communication par voie électronique. <br>
      C'est la cas des cookies déposés par Stripe, pour garantir une bonne exécution des paiements en ligne.</p>

    <p>cookies nécessitant au préalable le recueil de votre consentement
      (cookies publicitaires) : cette exigence concerne les cookies émis par des
      tiers et qui sont qualifiés de « persistants » dans la mesure où ils
      demeurent dans votre terminal jusqu’à leur effacement ou leur date d’expiration.<br>
    C'est la cas des cookies déposés par google pour améliorer l'expérience publicitaire de nos utilisateurs.</p>

    <p>Vous pouvez vous opposer à l’enregistrement des cookies en paramétrant votre navigateur de la manière suivante :</p>

    <p>Pour Chrome :</p>

    <pre>Sur votre ordinateur, ouvrez Chrome.
    En haut à droite, cliquez sur Plus.
    Cliquez sur « Plus d’outils » « Effacer les données de navigation ».
    En haut de la page, choisissez une période. …
    Cochez les cases face à « Cookies et données de site » et « Images et fichiers en cache ».
    Cliquez sur « Effacer les données ».</pre>

    <p>Pour Mozilla Firefox :</p>

    <pre>Choisissez le menu « Outil » puis « Options »
    Cliquez sur l’icône « Vie privée »
    Repérez le menu « Cookie » et sélectionnez les options qui vous conviennent
    Pour Microsoft Internet Explorer :
    Choisissez le menu « Outils » (ou « Tools ») puis « Options Internet » (ou « Internet Options »)
    Cliquez sur l’onglet « Confidentialité » (ou « Confidentiality »)
    Sélectionnez le niveau souhaité à l’aide du curseur.</pre>

    <p>Pour Edge :</p>

    <pre>Allez dans « Paramètres »
    Sous « Effacer les données de navigation », sélectionnez « Choisir les éléments à effacer »
    Cochez les cases en regard de chaque type de données que vous souhaitez effacer, puis sélectionnez « Effacer ».</pre>

    <p>Pour Opéra :</p>

    <pre>Choisissez le menu « Fichier » > « Préférences »
      « Vie privée ».</pre>

    <p>Nous attirons votre attention sur le fait que le refus du dépôt de cookies
      sur votre terminal est néanmoins susceptible d’altérer votre expérience
      d’utilisateur ainsi que votre accès à certains services ou fonctionnalités du {{ site }}.</p>

    <p>Pour connaître les modalités applicables à la gestion des cookies stockés
      dans votre navigateur, nous vous invitons à consulter le menu d’aide de
      votre navigateur ainsi que la rubrique « Vos traces » du site de la CNIL (Commission Nationale de l’Informatique & des Libertés) :
    http://www.cnil.fr/vos-libertes/vos-traces/les-cookies/</p>
  </div>
</template>

<script>
export default {
  computed: {
    mailto () {
      return 'mailto:' + this.contact
    },
    url () {
      return 'https://' + this.site
    },
    site () {
      return window.location.hostname
    }
  }
}
</script>

<style lang="scss" scoped>
  div {
    font-size: 12px;
    padding: 0 25px;
    overflow: auto;
    height: 8em;
  }
</style>



// WEBPACK FOOTER //
// src/components/rgpd.vue